import React, { Component } from "react";

class Clear extends Component {
    render() {
      return (
        <div style={{clear: 'both'}} >
        </div>
      );
    }
}

export default Clear;


// WEBPACK FOOTER //
// ./src/components/Structure/Clear.jsx